import { Injectable, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LicenseInfoService } from '@kempower-nx-workspace/chargeye-licensing';
import { map, startWith } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SidePanelNavigationService {
    hasNewNotification = signal(false);
    newProductUpdateCount = signal(0);
    licenseInfoService = inject(LicenseInfoService);
    toggleNavNotificationIcon() {
        this.hasNewNotification.set(!this.hasNewNotification());
    }

    getRouteMenu$(route: ActivatedRoute) {
        return route.data.pipe(
            startWith({ routeMenu: [] }),
            map((data) => {
                return data['routeMenu'];
            })
        );
    }
}
